var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loaderWrapper",class:{ fadeIn: _vm.isActive, fadedOut: !_vm.isActive }},[_c('LoaderIndicator'),_c('h4',{staticClass:"info"},[_vm._v(_vm._s(_vm.title))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }